/**
 * JobRequestStatusBadge
 *
 * Estado de una solicitud de vacante: mapea cada estatus a un color y deja
 * que el Badge compartido ponga el tamaño y los tonos.
 */

import React from 'react'
import { Badge } from '@/shared/components/Badge'
import type { ColorDeBadge } from '@/shared/components/Badge'

interface StatusConfig {
  label: string
  color: ColorDeBadge
}

const statusConfigs: Record<string, StatusConfig> = {
  pendiente_pre_aprobacion: { label: 'Pendiente Pre-aprobación', color: 'amarillo' },
  pendiente_validacion_pm: { label: 'Pendiente Pre-aprobación', color: 'amarillo' },
  pre_aprobada: { label: 'Pre-aprobada', color: 'azul' },
  pendiente_aprobacion_salario: { label: 'Pendiente Aprobación Salario', color: 'amarillo' },
  en_revision_salarios: { label: 'Pendiente Aprobación Salario', color: 'amarillo' },
  devuelta_rh: { label: 'Devuelta a RH', color: 'naranja' },
  pendiente_validacion_rh: { label: 'Pendiente RH', color: 'amarillo' },
  en_revision: { label: 'Pre-aprobada', color: 'azul' },
  devuelta: { label: 'Devuelta', color: 'naranja' },
  vacante_activa: { label: 'Vacante Activa', color: 'verde' },
  aprobada: { label: 'Vacante Activa', color: 'verde' },
  rechazada: { label: 'Rechazada', color: 'rojo' },
  en_proceso_contratacion: { label: 'En Contratación', color: 'azul' }
}

interface JobRequestStatusBadgeProps {
  status: string
  className?: string
  /** @deprecated Los badges de estatus van sin ícono; se ignora. */
  showIcon?: boolean
  /** @deprecated El tamaño lo decide el Badge; se ignora. */
  size?: 'sm' | 'md' | 'lg'
}

const JobRequestStatusBadge: React.FC<JobRequestStatusBadgeProps> = ({
  status,
  className = ''
}) => {
  const config = statusConfigs[status] || { label: status, color: 'gris' as ColorDeBadge }

  return (
    <Badge color={config.color} className={className}>
      {config.label}
    </Badge>
  )
}

export default JobRequestStatusBadge
